import React from 'react';
import Text from '../../../elements/Text';
import { T } from '../../../helpers/i18n';
import { BlockSeparator } from './BlockSeparator';
export var BlockAfiliate = function (_a) {
    var item = _a.item;
    return (React.createElement(React.Fragment, null,
        item.afiliateName && (React.createElement(React.Fragment, null,
            React.createElement(Text, { style: { marginTop: 0, marginBottom: 0 } }, "".concat(T('afiliate'), ": ").concat(item.afiliateName)))),
        item.afiliateName && React.createElement(BlockSeparator, null)));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockAfiliate.tsx
// module id = 1191
// module chunks = 0